"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var _draftJs = _interopRequireWildcard(require("draft-js"));

var _draftExtend = require("draft-extend");

var _changeBlockData = _interopRequireDefault(require("draft-plugins/utils/changeBlockData"));

var _insertAtomicBlockWithData = _interopRequireDefault(require("draft-plugins/utils/insertAtomicBlockWithData"));

var _constants = require("draft-plugins/lib/constants");

var DRAFT_ATOMIC_TYPE_VIDEO = 'VIDEO';

var getEntity = function getEntity(contentBlock, callback) {
  contentBlock.findEntityRanges(function (character) {
    return character.getEntity() !== null;
  }, callback);
};

var toggleUndo = function toggleUndo(editorState, allowUndo) {
  return _draftJs.EditorState.set(editorState, {
    allowUndo: allowUndo
  });
};

var RichTextEditorContentMediatorRecord = (0, _immutable.Record)({
  config: null,
  toHtml: null,
  fromHtml: null,
  hasContent: null,
  draft: _draftJs.default,
  utils: {
    changeBlockData: _changeBlockData.default,
    insertAtomicBlockWithData: _insertAtomicBlockWithData.default,
    pluginUtils: _draftExtend.pluginUtils
  }
});

var RichTextEditorContentMediator =
/*#__PURE__*/
function (_RichTextEditorConten) {
  (0, _inherits2.default)(RichTextEditorContentMediator, _RichTextEditorConten);

  function RichTextEditorContentMediator() {
    (0, _classCallCheck2.default)(this, RichTextEditorContentMediator);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(RichTextEditorContentMediator).apply(this, arguments));
  }

  (0, _createClass2.default)(RichTextEditorContentMediator, [{
    key: "getAtMentions",
    value: function getAtMentions(content) {
      var entities = [];
      content.getBlocksAsArray().forEach(function (block) {
        return getEntity(block, function (start) {
          return entities.push(block.getEntityAt(start));
        });
      });
      return entities.reduce(function (list, entityKey) {
        var getEntityForKey = content.getEntity || _draftJs.Entity.get;
        var entity = getEntityForKey(entityKey);

        if (entity) {
          var data = entity.get('data');

          if (data) {
            var ownerId = parseInt(data.value, 10);

            if (ownerId && !isNaN(ownerId) && !list.has(ownerId)) {
              list = list.push(ownerId);
            }
          }
        }

        return list;
      }, (0, _immutable.List)());
    }
  }, {
    key: "getNumberOfImages",
    value: function getNumberOfImages(content) {
      return content.getBlockMap().filter(function (block) {
        return block.getData().get('atomicType') === _constants.IMAGE_ATOMIC_TYPE;
      }).count();
    }
  }, {
    key: "getNumberOfVideos",
    value: function getNumberOfVideos(content) {
      return content.getBlockMap().filter(function (block) {
        return block.getData().get('atomicType') === DRAFT_ATOMIC_TYPE_VIDEO;
      }).count();
    } // Links are stored as entities. To find keys for potential link entities,
    // we should find blocks with text properties and use their entity keys.

  }, {
    key: "getNumberOfLinks",
    value: function getNumberOfLinks(content) {
      var textEntities = (0, _immutable.List)();

      if (typeof content.getEntity !== 'function') {
        return textEntities;
      }

      content.getBlockMap().filter(function (block) {
        return block.getText();
      }).forEach(function (block) {
        block.findEntityRanges(function (character) {
          if (character.getEntity()) {
            textEntities = textEntities.push(content.getEntity(character.getEntity()));
          }
        });
      });
      return textEntities.filter(function (entity) {
        return entity.getType() === _constants.LINK_ENTITY_TYPE;
      }).size;
    }
  }, {
    key: "setContent",
    value: function setContent(editorState, contentState) {
      var undoable = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (!undoable) {
        editorState = toggleUndo(editorState, false);
      }

      editorState = _draftJs.EditorState.push(editorState, contentState);

      if (!undoable) {
        editorState = toggleUndo(editorState, true);
      }

      return editorState;
    }
  }, {
    key: "resetContent",
    value: function resetContent() {
      return _draftJs.EditorState.createEmpty();
    }
  }, {
    key: "toJson",
    value: function toJson(contentState) {
      return (0, _draftJs.convertToRaw)(contentState);
    }
  }, {
    key: "fromJson",
    value: function fromJson(rawContentState) {
      return (0, _draftJs.convertFromRaw)(rawContentState).update('blockMap', function (blockMap) {
        return blockMap.map(function (block) {
          if (block.get('type') === 'atomic' && [_constants.IMAGE_ATOMIC_TYPE, DRAFT_ATOMIC_TYPE_VIDEO].includes(block.getIn(['data', 'atomicType']))) {
            var data = (0, _immutable.fromJS)(block.get('data').toJS());
            return block.set('data', data);
          }

          return block;
        });
      });
    }
  }]);
  return RichTextEditorContentMediator;
}(RichTextEditorContentMediatorRecord);

exports.default = RichTextEditorContentMediator;
module.exports = exports.default;